module.exports = __webpack_public_path__ + "img/aircraft_box2.b734e983.png";